<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-infantil')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="p-4 shadow-sm card__sistemacpv">
          <b-nav class="nav-books" tabs fill>
            <b-nav-item
              @click="setActive(index)"
              :class="{ active: activeIndex === index }"
              :active="activeIndex === index"
              v-for="(menu, index) in lists"
              :key="index"
            >
              <i :class="menu.iconClass"></i>
              <span class="mr-auto">{{ menu.name }}</span>
            </b-nav-item>
          </b-nav>
          <div v-for="(menu, index) in lists" :key="index">
            <b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
              <div class="mt-3" v-if="menu.turmas">
                <b-card no-body v-for="(turma, idx) in menu.turmas" :key="idx" class="mt-2 border-light shadow-none">
                  <template #header>
                    <div
                      @click="toggleCollapse('colecaoCpv', idx)"
                      class="button-toggle p-3"
                      v-if="menu.name == 'Coleção CPV'"
                    >
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"
                          ><strong>{{ turma.name }}</strong>
                          <span v-if="turma.otherName != ''">- ({{ turma.otherName }})</span></span
                        >
                        <i :class="collapsedStates.colecaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div
                      @click="toggleCollapse('manualCpv', idx)"
                      class="button-toggle p-3"
                      v-if="menu.name == 'Manual'"
                    >
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"
                          ><strong>{{ turma.name }}</strong>
                          <span v-if="turma.otherName != ''">- ({{ turma.otherName }})</span></span
                        >
                        <i :class="collapsedStates.manualCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div
                      @click="toggleCollapse('musicaCpv', idx)"
                      class="button-toggle p-3"
                      v-if="menu.name == 'Músicas'"
                    >
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"
                          ><strong>{{ turma.name }}</strong>
                          <span v-if="turma.otherName != ''">- ({{ turma.otherName }})</span></span
                        >
                        <i :class="collapsedStates.musicaCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                  </template>
                  <b-collapse v-model="collapsedStates.colecaoCpv[idx]" v-if="menu.name == 'Coleção CPV'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link
                            :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                              query: { material: formatParam(book.description) },
                            }"
                          >
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.manualCpv[idx]" v-if="menu.name == 'Manual'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link
                            :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                              query: { material: formatParam(book.description) },
                            }"
                          >
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.musicaCpv[idx]" v-if="menu.name == 'Músicas'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" md="6" lg="4" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <b-link :href="book.linkUrl" alt="Link para musicas infantis">
                            <b-card no-body class="p-3">
                              <div class="d-flex justify-content-baseline">
                                <span class="font-weight-light text-dark mr-auto">{{ book.name }}</span>
                                <span class="font-weight-bold text-dark small">{{ book.caderno }}</span>
                              </div>
                            </b-card>
                          </b-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </b-card>
                <div class="d-flex justify-content-center mt-3" v-if="menu.name == 'Músicas'">
                  <b-link
                    href="http://www.letras.com.br/musicas-infantis"
                    class="btn btn_sistemacpv"
                    variant="transparent"
                    target="_blank"
                  >
                    <span style="font-size: 14px">Confira outras sugestões.</span>
                  </b-link>
                </div>
              </div>
              <div class="mt-3" v-else>
                <b-card no-body class="mt-2 border-0 shadow-none">
                  <b-row>
                    <b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
                      <router-link
                        :to="{
                          name: 'render-conteudo-exclusivo',
                          params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                          query: { material: formatParam(book.description) },
                        }"
                      >
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </router-link>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>

    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503(temPermissao('segmento-infantil')) }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'dash-infantil',
    data() {
      return {
        pageTitle: 'Educação Infantil',
        pageSubtitle: '',
        NamePermission: '',
        IndexPermission: '',

        activeIndex: 0,

        collapsedStates: {
          colecaoCpv: [],
          manualCpv: [],
          musicaCpv: [],
        },

        lists: [
          {
            id: 1,
            name: 'Coleção CPV',
            iconClass: 'fa-solid fa-book fa-sm mr-1',
            link_name: 'programacao',
            colorCard: {
              'background-color': '#4ac8aa',
              'border:': '1px solid #4ac8aa',
              'border-radius': '0.5rem',
            },
            permission: 'segmento-infantil',
            bg__link: 'fundamental-i',
            turmas: [
              {
                name: 'Infantil - 2',
                otherName: 'Maternal I',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Coleção Experimentando - Infantil 2 - Caderno 1',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/colecao/infantil-2-maternal-1/ed-infantil-2-cad-1_versao-2021-web.pdf',
                    description:
                      'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 1.',
                    isbn: 'ISBN: 9788584510344',
                  },
                  {
                    name: 'Coleção Experimentando - Infantil 2 - Caderno 2',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/colecao/infantil-2-maternal-1/ed-infantil-2-maternal-i-cad-2.pdf',
                    description:
                      'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 2.',
                    isbn: 'ISBN: 9788584510535',
                  },
                ],
              },
              {
                name: 'Infantil - 3',
                otherName: 'Maternal II',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Coleção Experimentando - Infantil 3 - Caderno 1',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL2',
                    linkFree: 'infantil/colecao/infantil-3-maternal-2/ed-infantil-3-cad-1_versao-2021-web.pdf',
                    description:
                      'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 1.',
                    isbn: 'PROG-0001',
                  },
                  {
                    name: 'Coleção Experimentando - Infantil 3 - Caderno 2',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL2',
                    linkFree: 'infantil/colecao/infantil-3-maternal-2/ed-infantil-3-maternal-ii-cad-2.pdf',
                    description:
                      'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 2.',
                    isbn: 'PROG-0002',
                  },
                  {
                    name: 'Coleção Descobrindo - Infantil 3 - Inglês',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL2',
                    linkFree: 'infantil/colecao/infantil-3-maternal-2/ed-infantil-3-maternal-ii-ingles.pdf',
                    description:
                      'A Coleção Experimentando é composta de dois Cadernos um por semestre, esse é o caderno 2.',
                    isbn: 'PROG-0002',
                  },
                ],
              },
              {
                name: 'Infantil - 4',
                otherName: 'Jardim I',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 1',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM1',
                    linkFree: 'infantil/colecao/infantil-4-jardim-1/ed-infantil-4-cad-1_versao-2021-web-1.pdf',
                    description: 'Conhecendo a Coleção - Jardim I - Caderno 1',
                    isbn: 'ISBN: 978-85-8451-035-1',
                  },
                  {
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 2',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM1',
                    linkFree: 'infantil/colecao/infantil-4-jardim-1/ed-infantil-jardim-i-cad-2.pdf',
                    description: 'Conhecendo a Coleção - Jardim I - Caderno 2',
                    isbn: 'ISBN: 978-85-8451-036-8',
                  },
                  {
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 3',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM1',
                    linkFree: 'infantil/colecao/infantil-4-jardim-1/ed-infantil-4-jardim-i-cad-3.pdf',
                    description: 'Conhecendo a Coleção - Jardim I - Caderno 3',
                    isbn: 'ISBN: 978-85-8451-036-8',
                  },
                  {
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 4',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM1',
                    linkFree: 'infantil/colecao/infantil-4-jardim-1/ed-infantil-4-jardim-i-cad-4.pdf',
                    description: 'Coleção Conhecendo - Infantil 4 - Caderno 4',
                    isbn: 'ISBN: 978-85-8451-055-9',
                  },
                  {
                    name: 'Coleção Conhecendo - Infantil 4 - Inglês',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM1',
                    linkFree: 'infantil/colecao/infantil-4-jardim-1/ed-Infantil-4-Ingles.pdf',
                    description: 'Coleção Conhecendo - Infantil 4 - Inglês',
                    isbn: 'ISBN: 978-85-8451-055-9',
                  },
                ],
              },
              {
                name: 'Infantil - 5',
                otherName: 'Jardim II',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Coleção Vivenciando - Infantil 5 - Caderno 1',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM2',
                    linkFree: 'infantil/colecao/infantil-5-jardim-2/ed-infantil-5-cad-1_versao-2021-web.pdf',
                    description: 'Vivenciando Jardim II Caderno 1',
                    isbn: 'ISBN: 978-85-8451-050-4',
                  },
                  {
                    name: 'Coleção Vivenciando - Infantil 5 - Caderno 2',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM2',
                    linkFree: 'infantil/colecao/infantil-5-jardim-2/ed-infantil-jardim-ii-cad-2.pdf',
                    description: 'Vivenciando Jardim II - Caderno 2 ',
                    isbn: 'ISBN: 978-85-8451-052-8',
                  },
                  {
                    name: 'Coleção Vivenciando - Infantil 5 - Caderno 3',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM2',
                    linkFree: 'infantil/colecao/infantil-5-jardim-2/ed-infantil-5-jardim-ii-cad-3-1.pdf',
                    description: 'Vivenciando Jardim II - Caderno 3',
                    isbn: 'ISBN: 978-85-8451-056-6',
                  },
                  {
                    name: 'Coleção Vivenciando - Infantil 5 - Caderno 4',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM2',
                    linkFree: 'infantil/colecao/infantil-5-jardim-2/ed-infantil-5-jardim-ii-cad-4.pdf',
                    description: 'Vivenciando Jardim II - Caderno 4',
                    isbn: 'ISBN: 978-85-8451-057-3',
                  },
                  {
                    name: 'Coleção Vivenciando - Infantil 5 - Inglês',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_JARDIM2',
                    linkFree: 'infantil/colecao/infantil-5-jardim-2/ed-Infantil-5-Ingles.pdf',
                    description: 'Vivenciando Jardim II - Inglês',
                    isbn: 'ISBN: 978-85-8451-057-3',
                  },
                ],
              },
              {
                name: 'Flashcards',
                otherName: '',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Box 1 - Alphabeth',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-1-alphabeth.pdf',
                    description: 'Box 1 Alphabeth',
                    isbn: 'Cards',
                  },
                  {
                    name: 'Box 2 - Food',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-2-food.pdf',
                    description: 'Box 2 Food',
                    isbn: 'Cards',
                  },
                  {
                    name: 'Box 3 - Animals',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-3-animals.pdf',
                    description: 'Box 3 Animals',
                    isbn: 'Cards',
                  },
                  {
                    name: 'Box 4 - Body + Commands',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-4-body-commands.pdf',
                    description: 'Box 4 Body',
                    isbn: 'Cards',
                  },
                  {
                    name: 'Box 5 - Home + Family + Feelings',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-5-home-family-feelings.pdf',
                    description: 'Box 5 Family',
                    isbn: 'Cards',
                  },
                  {
                    name: 'Box 6 - Numbers + Colors + Shapes',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_CARDS',
                    linkFree: 'infantil/colecao/flash-cards/box-6-numbers-colors-shapes.pdf',
                    description: 'Box 6 Colors and Shapes',
                    isbn: 'Cards',
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            name: 'Programação',
            iconClass: 'fa-solid fa-calendar-days fa-sm mr-1',
            link_name: 'programacao',
            colorCard: {
              'background-color': '#4ac8aa',
              'border:': '1px solid #4ac8aa',
              'border-radius': '0.5rem',
            },
            permission: 'segmento-infantil',
            bg__link: 'fundamental-i',
            books: [
              {
                name: 'Coleção Primeiras Descobertas - Proposta Pedagógica e Programação',
                iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                bundle: 'F_INFANTIL',
                segment: 'S_MATERNAL1',
                linkFree: 'infantil/programacao/proginfantil1.pdf',
                description: 'Manual de Orientações para o Coordenador',
                isbn: 'Manual',
              },
              {
                name: 'Programação Educação Infantil - Inglês',
                iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                bundle: 'F_INFANTIL',
                segment: 'S_MATERNAL1',
                linkFree: 'infantil/programacao/programacao_ingles-anual.pdf',
                description: 'Inglês para Crianças',
              },
            ],
          },
          {
            id: 3,
            name: 'Manual',
            iconClass: 'fa-solid fa-notebook fa-sm mr-1',
            link_name: 'manual',
            colorCard: {
              'background-color': '#a7dc48',
              'border:': '1px solid #a7dc48',
              'border-radius': '0.5rem',
            },
            permission: 'segmento-infantil',
            bg__link: 'fundamental-ii',
            turmas: [
              {
                name: 'Infantil - 2',
                otherName: 'Maternal I',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Manual de Orientações para o Coordernador',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/manual/infantil-2/manual-coodenador.pdf',
                    description: 'Manual de Orientações para o Coordernador',
                    isbn: 'Manual',
                  },
                  {
                    name: 'Manual de Orientações para o Professor - Educação Física',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/manual/infantil-2/Manual-Educacao-Fisica-Maternal-I-e-II.pdf',
                    description: 'Manual Educação Física - Maternal - I e II',
                    isbn: 'Manual',
                  },
                  {
                    name: 'Manual do Professor - Infantil 2 - Caderno 1',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/manual/infantil-2/ed-infantil-2-cad-1_versao-2021-manual-web.pdf',
                    description: 'Manual do Professor - Maternal-infantil 2 caderno 1',
                    isbn: 'Manual',
                  },
                  {
                    name: 'Manual do Professor - Infantil 2 - Caderno 2',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/manual/infantil-2/manual-ed-infantil-maternal-i-cad-2_versao-2018.pdf',
                    description: 'Manual do Professor Maternal - infantil 2 - caderno 2',
                    isbn: 'Manual',
                  },
                  {
                    name: 'Os 30 melhores Livros Infantis',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    linkFree: 'infantil/manual/infantil-2/30-melhores-livros-infantis.pdf',
                    description: 'Os 30 Melhores Livros do Ano',
                    isbn: 'Dicas',
                  },
                ],
              },
              {
                name: 'Infantil - 3',
                otherName: 'Maternal II',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkFree: 'infantil/manual/infantil-3/manual-coodenador.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_3-1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Coordenador',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: 'Manual para Orientações para o Coordenador',
                    toolTip: 'Manual de Orientações para o Coordenador1',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-2/Manual-Educacao-Fisica-Maternal-I-e-II.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil_2_c2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Professor - Educação Física',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: 'Manual Educação Física - Maternal - I e II',
                    toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-3/manual_ingles-infantil-3-1_web.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_3-ing.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Professor - Inglês',
                    segment: 'S_MATERNAL2',
                    discipline: 'Língua Inglesa',

                    description: 'Manual - inglês - Manual de Orientações Metodológicas',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-3/ed-infantil-3-cad-1_versao-2021-manual-web.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_3-1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Descobrindo - Infantil 3 - Caderno 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',

                    description: 'Manual do Professor infantil 3 Caderno 1',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-3/manual-ed-infantil-maternal-ii-cad-2_versao-2018.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_3-2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Descobrindo - Infantil 3 - Caderno 2',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: 'Manual do Professor infantil 3 Caderno 2',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-2/30-melhores-livros-infantis.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_30-melhoresLivros.png ',
                    bundle: 'F_INFANTIL',
                    name: 'Os 30 melhores Livros Infantis',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: 'Os 30 Melhores Livros do Ano',
                    toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre',
                    isbn: 'Dicas',
                  },
                ],
              },
              {
                name: 'Infantil - 4',
                otherName: 'Jardim I',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkFree: 'infantil/manual/infantil-4/manual-coodenador.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil2_c1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Coordernador',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual de Orientações para o Coordenador',
                    toolTip: 'Manual de Orientações para o Coordenador1',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/Manual-Educacao-Fisica-Jardim-I-e-II.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações do Professor - Educação Física',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Jardim I Infantil 4 Caderno 1',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/manual_ingles-infantil-4-1.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-ing.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Professor - Inglês',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Inglês',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/ed-infantil-4-cad-1_versao-2021-manual-web.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 1',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Jardim I Infantil 4 Caderno 2',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/manual-ed-infantil-jardim-i-cad-2.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 2',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Jardim I Infantil 4 Caderno 2',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/manual-ed-infantil-jardim-i-cad-31.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-3.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 3',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Jardim I Infantil 4 Caderno 3',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/manual-ed-infantil-jardim-i-cad-41.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_4-4.png',
                    bundle: 'F_INFANTIL',
                    name: 'Coleção Conhecendo - Infantil 4 - Caderno 4',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Manual do Professor Jardim I Infantil 4 Caderno 4',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-2/30-melhores-livros-infantis.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_30-melhoresLivros.png ',
                    bundle: 'F_INFANTIL',
                    name: 'Os 30 melhores Livros Infantis',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: 'Os 30 Melhores Livros do Ano',
                    toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre',
                    isbn: 'Dicas',
                  },
                ],
              },
              {
                name: 'Infantil - 5',
                otherName: 'Jardim II',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkFree: 'infantil/manual/infantil-2/manual-coodenador.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil2_c1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Coordernador',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual de Orientações para o Coordenador',
                    toolTip: 'Manual de Orientações para o Coordenador1',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-4/Manual-Educacao-Fisica-Jardim-I-e-II.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_infantil_2_c2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Professor - Educação Física',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual Educação Física - Maternal - I e II',
                    toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-5/manual_ingles-infantil-5-cad-1_web.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_5-1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual de Orientações para o Professor - Inglês',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual do Professor Jardim II Infantil 5 Caderno 1',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-5/ed-infantil-5-cad-1_versao-2021-manual-web.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_5-1.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual do Professor - Vivenciando - Caderno 1',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual do Professor Jardim II Infantil 5 Caderno 1',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-5/manual-ed-infantil-jardim-ii-cad-2_versao-2018.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_5-2.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual do Professor - Vivenciando - Caderno 2',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual do Professor Jardim II Infantil 5 Caderno 2',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-5/manual-ed-infantil-jardim-ii-cad-3_versao-2018.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_5-3.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual do Professor - Vivenciando - Caderno 3',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual do Professor Jardim II Infantil 5 Caderno 3',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-5/manual-ed-infantil-jardim-ii-cad-41.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_5-4.png',
                    bundle: 'F_INFANTIL',
                    name: 'Manual do Professor - Vivenciando - Caderno 4',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Manual do Professor Jardim II Infantil 5 Caderno 4',
                    toolTip: '',
                    isbn: 'Manual',
                  },
                  {
                    linkFree: 'infantil/manual/infantil-2/30-melhores-livros-infantis.pdf',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_30-melhoresLivros.png ',
                    bundle: 'F_INFANTIL',
                    name: 'Os 30 melhores Livros Infantis',
                    segment: 'S_JARDIM2',
                    discipline: '',
                    description: 'Os 30 Melhores Livros do Ano',
                    toolTip: 'A Coleção Experimentando é composta de dois Cadernos um por semestre',
                    isbn: 'Dicas',
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            name: 'Músicas',
            iconClass: 'fa-solid fa-music fa-sm mr-1',
            link_name: 'musicas',
            colorCard: {
              'background-color': '#fc5b5b',
              'border:': '1px solid #fc5b5b',
              'border-radius': '0.5rem',
            },
            permission: 'segmento-infantil',
            bg__link: 'medio',
            turmas: [
              {
                name: 'Infantil - 2',
                otherName: 'Maternal I',
                permission: 'segmento-infantil',
                books: [
                  {
                    name: 'Os Dedinhos',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    caderno: 'Cad. 1',
                    linkUrl: 'https://www.youtube.com/watch?v=YXlxFH7MCac',
                    videoId: 'YXlxFH7MCac',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    description: 'Música: A familia dos Dedos Infantil 2 – Caderno 1.',
                    isbn: 'Os dedinhos',
                  },
                  {
                    name: 'Cabeça, ombro, joelhos e pé',
                    iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                    caderno: 'Cad. 1',
                    linkUrl: 'https://www.youtube.com/watch?v=1t7hybiiM8w',
                    videoId: '1t7hybiiM8w',
                    bundle: 'F_INFANTIL',
                    segment: 'S_MATERNAL1',
                    description: 'Música: Cabeça, ombro, perna e pé - Infantil 2 – Caderno 1',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=cjONzZPJONc',
                    LinkFree: '',
                    videoId: 'cjONzZPJONc',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Fazendinha',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '<p>Música: Fazendinha</p><p><b>Infantil 2 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=jc-vTAaK7Rs',
                    bundle: 'F_INFANTIL',
                    name: 'Galinha do Vizinho',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=z8-yWOXXJ4Y',
                    LinkFree: '',
                    videoId: 'z8-yWOXXJ4Y&t=1s',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'O Pato',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '<p>Música: O Pato</p><p><b>Infantil 2 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=6kdw4cHZgo8',
                    LinkFree: '',
                    videoId: '6kdw4cHZgo8',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Salada de Frutas',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '',
                    toolTip: '',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=pMLWWiBvWX8',
                    LinkFree: '',
                    videoId: 'pMLWWiBvWX8',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Quem tem medo do lobo mau?',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '',
                    toolTip: '',
                    isbn: 'Hora de Cantar',
                  },
                  {
                    linkUrl: 'hhttps://www.youtube.com/watch?v=KIKC-YvKAxQ',
                    LinkFree: '',
                    videoId: 'KIKC-YvKAxQ',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Chapeúzinho Vermelho',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '<p>Lobo mau</p><p><b>Infantil 2 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Agora vamos cantar a música que o Lobo Mal canta',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=X58eZ1WBP1Y',
                    LinkFree: '',
                    videoId: 'X58eZ1WBP1Y',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Heigh Ho',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '<p>Eu Vou</p><p><b>Infantil 2 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando com os anões',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=uICUE0Hde10',
                    LinkFree: '',
                    videoId: 'uICUE0Hde10',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Festa no céu',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL1',
                    discipline: '',
                    description: '<p>Música da tartaruguinha</p><p><b>Infantil 2 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando a música da festa no céu',
                  },
                ],
              },
              {
                name: 'Infantil - 3',
                otherName: 'Maternal II',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=MuBgIfBR1kA',
                    LinkFree: '',
                    videoId: 'MuBgIfBR1kA',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Dona Aranha',
                    caderno: 'Cad. 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Dona Aranha </p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Cheguei…e vou cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=W_X0R5BP_g0',
                    LinkFree: '',
                    videoId: 'W_X0R5BP_g0',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Pintinho Amarelinho',
                    caderno: 'Cad. 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Pintinho amarelinho </p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Gostei de cantar, quero mais!',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=nW6gvjifd14',
                    LinkFree: '',
                    videoId: 'nW6gvjifd14',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Ta pronto seu lobo?',
                    caderno: 'Cad. 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Vamos passear na floresta</p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Quer aprender como se brinca?',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=0JkSpPZJDkE',
                    LinkFree: '',
                    videoId: '0JkSpPZJDkE',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'O sapo não lavava o pé',
                    caderno: 'Cad. 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>O sapo não lava o pé</p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Cantando…',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=v0rX7souIRI',
                    LinkFree: '',
                    videoId: 'v0rX7souIRI',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Para mamãe',
                    caderno: 'Cad. 1',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Para mamãe</p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Cantando para mamãe',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=3r4cadv1Cmw',
                    LinkFree: '',
                    videoId: '3r4cadv1Cmw',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Seu Lobato',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Seu Lobato</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando a música que tem os sons dos animais',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=YYz0tGoSz-4',
                    LinkFree: '',
                    videoId: 'YYz0tGoSz-4',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Amigo sol',
                    caderno: 'Cad. 2',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando uma música que fala sobre o sol',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=7LvhiPdCpuc',
                    LinkFree: '',
                    videoId: 'YYz0tGoSz-4',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Ten Little Indian',
                    caderno: 'Cad. Anual',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando uma música que fala sobre o sol',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=90w2RegGf9w',
                    LinkFree: '',
                    videoId: 'YYz0tGoSz-4',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Happy Birthday Song',
                    caderno: 'Cad. Anual',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando uma música que fala sobre o sol',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=qGcoN9fwCuU',
                    LinkFree: '',
                    videoId: 'YYz0tGoSz-4',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'How old are you?',
                    caderno: 'Cad. Anual',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando uma música que fala sobre o sol',
                  },
                ],
              },
              {
                name: 'Infantil - 4',
                otherName: 'Jardim I',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=z7OAAPb6eQs',
                    LinkFree: '',
                    videoId: 'z7OAAPb6eQs',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Bicharia',
                    caderno: 'Cad. 3',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Dona Aranha </p><p><b>Infantil 3 – Caderno 1</b></p>',
                    toolTip: '',
                    isbn: 'Cheguei…e vou cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=z8-yWOXXJ4Y',
                    LinkFree: '',
                    videoId: 'z8-yWOXXJ4Y?t=18',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'O pato',
                    caderno: 'Cad. 3',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: 'Dona Aranha - Infantil 3 – Caderno 1',
                    toolTip: '',
                    isbn: 'Cheguei…e vou cantar',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=emxbXiUZ1i0',
                    LinkFree: '',
                    videoId: 'emxbXiUZ1i0',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'O Circo',
                    caderno: 'Cad. 4',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Seu Lobato</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando a música que tem os sons dos animais',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=x23rTDl4AMs',
                    LinkFree: '',
                    videoId: 'emxbXiUZ1i0',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Hello, Hello',
                    caderno: 'Cad. 4',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Seu Lobato</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando a música que tem os sons dos animais',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=e_04ZrNroTo',
                    LinkFree: '',
                    videoId: 'emxbXiUZ1i0',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Wheels on the bus',
                    caderno: 'Cad. 4',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Seu Lobato</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando a música que tem os sons dos animais',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=qGcoN9fwCuU',
                    LinkFree: '',
                    videoId: 'YYz0tGoSz-4',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'How old are you?',
                    caderno: 'Cad. Anual',
                    segment: 'S_MATERNAL2',
                    discipline: '',
                    description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando uma música que fala sobre o sol',
                  },
                ],
              },
              {
                name: 'Infantil - 5',
                otherName: 'Jardim II',
                permission: 'segmento-infantil',
                books: [
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=9yvuTmUfhn8',
                    LinkFree: '',
                    videoId: '9yvuTmUfhn8',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Pula fogueira',
                    caderno: 'Cad. 2',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: '<p> Pula a fogueira</p><p><b>Infantil 5 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'A música da festa junina',
                  },
                  {
                    linkUrl: 'https://www.youtube.com/watch?v=LiFzA-gpO9U',
                    LinkFree: '',
                    videoId: 'LiFzA-gpO9U',
                    src: '',
                    bundle: 'F_INFANTIL',
                    name: 'Capelinha de São João',
                    caderno: 'Cad. 2',
                    segment: 'S_JARDIM1',
                    discipline: '',
                    description: '<p>Capelinha de melão</p><p><b>Infantil 5 – Caderno 2</b></p>',
                    toolTip: '',
                    isbn: 'Cantando mais uma música!',
                  },
                ],
              },
            ],
          },
        ],

        showAccordion: false,
      }
    },
    created() {
      this.$emit('update-header', {
        title: this.pageTitle,
        subtitle: this.pageSubtitle,
      })
    },
    computed: {
      permissions() {
        return this.$store.state.auth.userpermissions.permissions
      },
      error503: function (value) {
        console.log(valeu + 545454)
        if (!value) {
          return (window.location.href = '/nao-autorizado')
        } else {
          return null
        }
      },
    },

    methods: {
      temPermissao(permissao) {
        return this.permissions.includes(permissao)
      },

      isToggleMaternalI() {
        this.isMaternalICollapsed = !this.isMaternalICollapsed
      },

      setActive(index) {
        if (this.activeIndex === index) return
        this.activeIndex = index
      },

      clearActive(index) {
        if (this.activeIndex === index) {
          this.activeIndex = null
        }
      },

      toggleCollapse(type, idx) {
        if (!Array.isArray(this.collapsedStates[type])) {
          this.$set(this.collapseStates, type, [])
        }

        this.collapsedStates[type].forEach((_, index) => {
          this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
        })
      },

      formatParam(param) {
        return param.replace(/\s+/g, '-')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    margin-top: 30px;
  }

  .card_sistemacpv {
    border-radius: 8px;
    color: #3a1c53;
  }

  .btn_sistemacpv {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 20px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: auto;

    color: #ffffff;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
      color: #ffffff;
    }
  }
</style>
